(function () {
  'use strict';

  function initImageBlockV3(root) {
    if (!root || root.getAttribute('data-ml353-bound') === '1') return;
    root.setAttribute('data-ml353-bound', '1');

    var track = root.querySelector('[data-ibv3-track]');
    var originals = Array.from(root.querySelectorAll('[data-ibv3-slide]'));
    var dotsWrap = root.querySelector('[data-ibv3-dots]');
    var prevBtn = root.querySelector('[data-ibv3-prev]');
    var nextBtn = root.querySelector('[data-ibv3-next]');
    var realCount = originals.length;
    if (!track || !realCount) return;

    var looping = realCount > 1;
    if (looping) {
      var firstClone = originals[0].cloneNode(true);
      firstClone.setAttribute('aria-hidden', 'true');
      track.appendChild(firstClone);
    }

    var slides = Array.from(root.querySelectorAll('[data-ibv3-slide]'));
    var current = 0;
    var startX = 0;
    var dragging = false;
    var dots = [];

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var d = 0; d < realCount; d += 1) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ibv3-dot' + (index === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
          dot.addEventListener('click', function () {
            go(index);
          });
          dotsWrap.appendChild(dot);
          dots.push(dot);
        })(d);
      }
    }

    function equalize() {
      slides.forEach(function (slide) {
        slide.style.height = '';
      });
      var max = 0;
      slides.forEach(function (slide) {
        max = Math.max(max, slide.offsetHeight);
      });
      if (!max) return;
      slides.forEach(function (slide) {
        slide.style.height = max + 'px';
      });
    }

    function stepSize() {
      return slides[0].getBoundingClientRect().width;
    }

    function realIndex(trackIndex) {
      if (!looping) return trackIndex;
      if (trackIndex === realCount) return 0;
      return trackIndex;
    }

    function syncDots() {
      var active = realIndex(current);
      dots.forEach(function (dot, i) {
        if (i === active) dot.classList.add('is-active');
        else dot.classList.remove('is-active');
      });
    }

    function setTransform(instant) {
      if (instant) {
        track.style.transition = 'none';
      }
      track.style.transform = 'translateX(' + (-current * stepSize()) + 'px)';
      if (instant) {
        track.offsetHeight;
        track.style.transition = '';
      }
    }

    function go(index, instant) {
      if (!looping) {
        if (index < 0) index = realCount - 1;
        if (index >= realCount) index = 0;
        current = index;
        setTransform(instant);
        syncDots();
        return;
      }
      if (index < 0) {
        current = realCount - 1;
        setTransform(true);
        syncDots();
        return;
      }
      if (index > realCount) index = realCount;
      current = index;
      setTransform(instant);
      syncDots();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        go(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        go(current + 1);
      });
    }

    track.addEventListener('transitionend', function (event) {
      if (event.target !== track || !looping) return;
      if (current === realCount) {
        go(0, true);
      }
    });

    track.addEventListener('pointerdown', function (e) {
      dragging = false;
      startX = e.clientX;
    });

    track.addEventListener('pointermove', function (e) {
      if (!startX) return;
      if (Math.abs(e.clientX - startX) > 8) dragging = true;
    });

    track.addEventListener('pointerup', function (e) {
      if (!startX) return;
      var diff = startX - e.clientX;
      startX = 0;
      if (Math.abs(diff) > 40) go(current + (diff > 0 ? 1 : -1));
      window.setTimeout(function () {
        dragging = false;
      }, 50);
    });

    track.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches[0]) return;
      startX = e.touches[0].clientX;
      dragging = false;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!startX || !e.touches || !e.touches[0]) return;
      if (Math.abs(e.touches[0].clientX - startX) > 8) dragging = true;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (!startX || !e.changedTouches || !e.changedTouches[0]) return;
      var diff = startX - e.changedTouches[0].clientX;
      startX = 0;
      if (Math.abs(diff) > 40) go(current + (diff > 0 ? 1 : -1));
    }, { passive: true });

    window.addEventListener('resize', function () {
      equalize();
      go(current, true);
    });

    root.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', equalize);
    });

    equalize();
    go(current, true);
  }

  function initAllImageBlockV3() {
    document.querySelectorAll('[data-ibv3]').forEach(initImageBlockV3);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllImageBlockV3);
  } else {
    initAllImageBlockV3();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    if (event.target.querySelector('[data-ibv3]')) initAllImageBlockV3();
  });
})();
